import { useTitle } from './use-title';

import { useStoreState } from '#root/store';

export const usePartyTitle = (prepend?: string) => {
  const title = useStoreState(state => state.party.party?.title);
  const newTitle = prepend && title ? `${prepend} - ${title}` : title;
  useTitle(newTitle);
};
